import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewContractRent from "./ViewContractRent";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Update_RentContract,
  View_Rent_Contract,
} from "../../../actions/Invoice_action";
import { Get_List_Rent_Contracts } from "../../../actions_agent/Invoice_action";
export class EditContractRentList extends Component {
  render() {
    const {
      rent_invoice_obj,
      lang,
      change_Lang,
      View_Rent_Contract,
      view_avilable_rent,
      Update_RentContract,
      user,
      EveryTimeTo_English,
      name_arb,
      name_en,
      name_krd,
      Get_List_Rent_Contracts,
      onClose,
    } = this.props;
    return (
      <Fragment>
        <ViewContractRent
          rent_invoice_obj={rent_invoice_obj}
          lang={lang}
          change_Lang={change_Lang}
          View_Rent_Contract={View_Rent_Contract}
          view_avilable_rent={view_avilable_rent}
          Update_RentContract={Update_RentContract}
          EveryTimeTo_English={EveryTimeTo_English}
          user={user}
          name_arb={name_arb}
          name_en={name_en}
          name_krd={name_krd}
          Get_List_Rent_Contracts={Get_List_Rent_Contracts}
          onClose={onClose}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rent_invoice_obj: state.Invoice_Reducer.rent_invoice_obj,
    rent_contracts: state.Invoice_Reducer.rent_contracts,
    lang: state.HelperReducer.lang,
    view_avilable_rent: state.Invoice_Reducer.view_avilable_rent,
    user: state.AuthReducer.user,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Rent_Contract: (id, index) => dispatch(View_Rent_Contract(id, index)),
    Update_RentContract: (id, data) => dispatch(Update_RentContract(id, data)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Get_List_Rent_Contracts: () => dispatch(Get_List_Rent_Contracts()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditContractRentList);
